import { render } from "./IntakeSummary.vue?vue&type=template&id=0412f9cd"
import script from "./IntakeSummary.vue?vue&type=script&lang=ts"
export * from "./IntakeSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script